import { React } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Helmet } from 'react-helmet';

import { METADATA } from '../../constants';
import Navbar from '../../components/HomeComponents/Navbar';
// import Footer from '../../components/HomeComponents/Footer';
import SectionOne from '../../components/HomeComponents/AboutUs/SectionOne';
import SectionTwo from '../../components/HomeComponents/AboutUs/SectionTwo';
import SectionThree from '../../components/HomeComponents/AboutUs/SectionThree';
import SectionFour from '../../components/HomeComponents/Sections/SectionFour';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  // sectionOne: {
  //   height: "500px",
  //   backgroundColor: "#e1eff6",
  // },
}));


export default function AboutUs() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Helmet>
        <meta name="description" content={METADATA.ABOUTUS.description} />
        <title>{METADATA.ABOUTUS.title}</title>
      </Helmet>
      <Navbar />
      <SectionOne />
      <SectionTwo />
      <SectionThree />
      <SectionFour />
    </div>
  )
}